__turbopack_context__.v({
  "className": "poppins_f6f3b026-module__7OUv3q__className",
  "variable": "poppins_f6f3b026-module__7OUv3q__variable",
});
